/* unplugin-vue-components disabled */import { render } from "./FileItem.vue?vue&type=template&id=5fbdc6df&scoped=true&ts=true"
import script from "./FileItem.vue?vue&type=script&lang=ts"
export * from "./FileItem.vue?vue&type=script&lang=ts"

import "./FileItem.vue?vue&type=style&index=0&id=5fbdc6df&lang=scss&scoped=true"

import exportComponent from "/var/static/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbdc6df"]])

export default __exports__